import { Users } from "react-feather";
import styled from "styled-components";
import { palette } from "../../../../styles/theme";

export const DuplicateAccountBadge = styled(Users).attrs({
  "aria-label": "Duplicate Linked Account Detected Tooltip",
})`
  color: ${palette.yellow};
`;
